import { AssetList } from '@goldcast/api/content';
import { getEnvConfig } from '@/constants';
import { Clip } from '@/player-config/src/types/clip-types';

export function getClipThumbnailUrl(clip: Clip | AssetList): string {
  const baseUrl = getEnvConfig('CLOUDFRONT_STATIC_ASSET_URL');
  const thumbnailRoot = getEnvConfig('THUMBNAIL_ROOT_FOLDER');
  const { project, id: contentId } = clip.content!;
  const assetId = clip.asset_metadata.id;

  const url = `${baseUrl}${thumbnailRoot}${project.id}/${contentId}/thumbnails/${assetId}.png`;

  return `${url}?${Math.random()}`;
}
